var render = function render(){var _vm=this,_c=_vm._self._c;return _c('form',{ref:"base-form",attrs:{"novalidate":""},on:{"submit":function($event){$event.preventDefault();return _vm.handleSubmit.apply(null, arguments)}}},[_vm._t("default",null,{"errors":_vm.errors,"validate":_vm.validate,"performValidate":_vm.performValidate})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }